module.exports = "<ace-editor\r\n  #editor\r\n  theme=\"twilight\"\r\n  [mode]=\"editorMode\"\r\n  [(text)]=\"editorText\"\r\n  [durationBeforeCallback]=\"10\"\r\n  (textChanged)=\"onEditorTextChanged($event)\"\r\n  style=\"width:100%; overflow: auto;\"\r\n></ace-editor>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/configuration/components/templates/configurationEditor.component.html
// module id = ./src/app/configuration/components/templates/configurationEditor.component.html
// module chunks = main